import React from "react";
import { RightPanel } from "../../../components/RightPanel/RightPanel";
import { Grid, Stack, Divider, Typography, Button } from "@mui/material";
import { StatusRenderer } from "../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PreviewTemplate } from "../../../components/Preview/PreviewTemplate";
import { LoadState } from "../../../constants/enums";
import { formatText } from "../../../helpers";
import WhatsappBgImg from "../../../assets/whatsapp_bg_img.jpg";
import { IQuickReplyTemplateData } from "../../../redux/quickReplyTemplates/quickReplyTemplate.types";

interface IViewQuickReplyTemplateDetailsProps {
  type: "TEMPLATE_LIST" | "ANALYTICS";
  open: boolean;
  onClose: () => void;
  quickReplyTemplateData?: IQuickReplyTemplateData;
}

export const ViewQuickReplyTemplateDetails = (
  props: IViewQuickReplyTemplateDetailsProps
) => {
  const { open, onClose, type, quickReplyTemplateData } = props;

  if (!quickReplyTemplateData) {
    return null;
  }

  return (
    <RightPanel
      paperSx={{ maxWidth: "500px" }}
      open={open}
      onClose={onClose}
      heading={`${formatText(quickReplyTemplateData.name)} Preview`}
      actionButtons={() => {
        return (
          <Stack direction={"row"} spacing={2} justifyContent={"flex-start"}>
            <Button variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </Stack>
        );
      }}
    >
      <Grid container spacing={2}>
        {/* Basic Info Section */}
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" fontWeight={600}>
              {formatText(quickReplyTemplateData.name)}
            </Typography>
            <StatusRenderer status={quickReplyTemplateData.status || ""} />
          </Stack>
        </Grid>

        {type === "TEMPLATE_LIST" && (
          <Grid item xs={12}>
            <Divider />
            <Typography variant="subtitle1" fontWeight={600} mt={2} mb={1}>
              Template Configuration
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Message Category:{" "}
              {quickReplyTemplateData.category || "QUICK_REPLY"}
            </Typography>
          </Grid>
        )}

        {/* WhatsApp Message Preview */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontWeight={600} mt={2} mb={1}>
            WhatsApp Message Preview
          </Typography>

          <Grid
            item
            xs={12}
            md={12}
            borderRadius={2}
            sx={{
              position: "sticky",
              top: 20,
              backgroundImage: `url(${WhatsappBgImg})`,
              minHeight: "55vh",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              mb: 2,
              display: "flex",
              pl: 4,
              pb: 4,
              pr: 10,
              pt: 2,
              alignItems: "flex-end",
            }}
          >
            <PreviewTemplate
              template={quickReplyTemplateData}
              loading={LoadState.Loaded}
              headerType="TEXT"
              bodyVariableValues={{}}
              isFromQuickReply={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </RightPanel>
  );
};
